import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import API_CONFIG, { buildApiUrl, buildApiUrlWithParams } from '../config/api';

const EventDetails = () => {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState('');
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [groups, setGroups] = useState("");

    useEffect(() => {
        fetchEvents();
    }, []);

    useEffect(() => {
        if (selectedEvent) {
            fetchRegistrations(selectedEvent);
        }
    }, [selectedEvent]);

    const fetchEvents = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error("No authentication token found.");
                return;
            } else {
                const decoded = JSON.parse(atob(token.split(".")[1]));
                setGroups(decoded["cognito:groups"]);
            }
            const response = await fetch(buildApiUrl(API_CONFIG.ENDPOINTS.EVENTS), {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Failed to fetch events');
            const data = await response.json();
            setEvents(data.filter(event => event.active));
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    const fetchRegistrations = async (eventId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(buildApiUrlWithParams(API_CONFIG.ENDPOINTS.EVENT_REGISTRATIONS, eventId), {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Failed to fetch registrations');
            const data = await response.json();
            setRegistrations(data);
        } catch (err) {
            setError(err.message);
        }
    };

    const handleEventChange = (e) => {
        setSelectedEvent(e.target.value);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    const selectedEventData = events.find(e => e.event_id === parseInt(selectedEvent));
    const eventTypeSchema = selectedEventData ? 
        JSON.parse(selectedEventData.specific_data_schema || '{"properties":[]}') : 
        { properties: [] };

    return (
        <div className="container mt-4">
            <Navbar groups={groups} />
            <h2>Event Details</h2>
            
            <div className="mb-4">
                <label className="form-label">Select Event</label>
                <select 
                    className="form-select" 
                    value={selectedEvent} 
                    onChange={handleEventChange}
                >
                    <option value="">Select an Event</option>
                    {events.map(event => (
                        <option key={event.event_id} value={event.event_id}>
                            {event.event_name} - {event.event_date}
                        </option>
                    ))}
                </select>
            </div>

            {selectedEvent && selectedEventData && (
                <>
                    {/* Event Details Card */}
                    <div className="card mb-4">
                        <div className="card-header">
                            <h3 className="card-title mb-0">Event Information</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <p><strong>Event Name:</strong> {selectedEventData.event_name}</p>
                                    <p><strong>Event Type:</strong> {selectedEventData.event_type_name}</p>
                                    <p><strong>Date:</strong> {selectedEventData.event_date}</p>
                                </div>
                                <div className="col-md-6">
                                    <p><strong>Status:</strong> {selectedEventData.active ? 'Active' : 'Inactive'}</p>
                                    <p><strong>Total Registrations:</strong> {registrations.length}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Registrations Table */}
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title mb-0">Registered Students</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Student Name</th>
                                            <th>Belt Rank</th>
                                            <th>Registration Fee</th>
                                            {eventTypeSchema.properties.map(prop => (
                                                <th key={prop.name}>{prop.title}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {registrations.map(registration => (
                                            <tr key={registration.event_registration_id}>
                                                <td>{registration.student_name}</td>
                                                <td>{registration.current_rank}</td>
                                                <td>${registration.event_fee}</td>
                                                {eventTypeSchema.properties.map(prop => (
                                                    <td key={prop.name}>
                                                        {JSON.parse(registration.event_specific_data)[prop.name] || '-'}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default EventDetails; 